module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUoAAADcBAMAAADkT/XcAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAD1BMVEWuHCjks7f///+2wtkhRos8O9fwAAAAAWJLR0QCZgt8ZAAAAAd0SU1FB+oDHgA7AynWdroAAACRSURBVHja7c5BEQAgDAOwWsACFmYB/5pQwaNHoiAJAAAAAAAAAAAAAAB8azXIbmBpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaVm3nAY5DSwtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS1fuLxA1if9KbEgAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDI2LTAzLTMwVDAwOjU5OjAzKzAwOjAwMgt8SgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyNi0wMy0zMFQwMDo1OTowMyswMDowMENWxPYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/nl.png
// module id = 2MA1
// module chunks = 128